import { render, staticRenderFns } from "./inactive-user.vue?vue&type=template&id=c5570298"
import script from "./inactive-user.vue?vue&type=script&lang=js"
export * from "./inactive-user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports